export const getServerErrorStatus = (state: any) => state.general?.serverErrorStatus;
